import type { TypographyType } from '@unifyapps/defs/blocks/Typography/types';

// stored `type` values are kept as-is for back-compat with existing blocks,
// but the names are misleading at call sites: stored `HTML` is actually rich text
// (ProseMirror/tiptap) and stored `PLAIN_HTML` is the one that means raw HTML.
// resolve once at the component boundary, then branch on the semantic name.
export type ResolvedTypographyType = 'MARKDOWN' | 'PLAIN_TEXT' | 'RICH_TEXT' | 'HTML';

export function resolveTypographyType(type: TypographyType): ResolvedTypographyType {
  switch (type) {
    case 'HTML':
      return 'RICH_TEXT';
    case 'PLAIN_HTML':
      return 'HTML';
    default:
      return type;
  }
}
